export const InputTypes = {
  DOCUMENT: 'document',
  DATA: 'data',
};

export const ComplianceStatusTypes = {
  PENDING: 'PENDING',
  SENT_TO_BANK: 'SENT_TO_BANK',
};
